export default __webpack_public_path__ + "static/media/1934.da40e090.png";